import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Building2, BarChart3 } from 'lucide-react';

const formatMarketCap = (value) => {
  if (!value) return 'N/A';
  if (value >= 1e12) return `$${(value / 1e12).toFixed(2)}T`;
  if (value >= 1e9) return `$${(value / 1e9).toFixed(2)}B`;
  if (value >= 1e6) return `$${(value / 1e6).toFixed(2)}M`;
  return `$${value.toLocaleString()}`;
};

const formatVolume = (value) => {
  if (!value) return 'N/A';
  if (value >= 1e9) return `${(value / 1e9).toFixed(2)}B`;
  if (value >= 1e6) return `${(value / 1e6).toFixed(2)}M`;
  if (value >= 1e3) return `${(value / 1e3).toFixed(2)}K`;
  return value.toLocaleString();
};

const Row = ({ icon, label, value }) => (
  <div className="flex justify-between items-center">
    <div className="flex items-center gap-2">
      {icon}
      <span className="text-gray-600">{label}</span>
    </div>
    <span className="font-semibold">{value}</span>
  </div>
);

const KeyMetricsCard = ({ stock }) => (
  <Card data-testid="key-metrics-card">
    <CardHeader>
      <CardTitle className="text-lg">Key Metrics</CardTitle>
    </CardHeader>
    <CardContent className="space-y-3">
      <Row
        icon={<Building2 size={18} className="text-purple-600" />}
        label="Market Cap"
        value={formatMarketCap(stock.marketCap)}
      />
      <Row
        icon={<BarChart3 size={18} className="text-blue-600" />}
        label="P/E Ratio"
        value={stock.peRatio ? stock.peRatio.toFixed(2) : 'N/A'}
      />
      <div className="flex justify-between items-center">
        <span className="text-gray-600">52W High</span>
        <span className="font-semibold">
          {stock.fiftyTwoWeekHigh ? `$${stock.fiftyTwoWeekHigh.toFixed(2)}` : 'N/A'}
        </span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-gray-600">52W Low</span>
        <span className="font-semibold">
          {stock.fiftyTwoWeekLow ? `$${stock.fiftyTwoWeekLow.toFixed(2)}` : 'N/A'}
        </span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-gray-600">Avg Volume</span>
        <span className="font-semibold">{formatVolume(stock.avgVolume)}</span>
      </div>
    </CardContent>
  </Card>
);

export default KeyMetricsCard;
